import { styled } from '@mui/material/styles';
import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material';

import { bgBlur } from '../../../utils/cssStyles';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------
import { NAV_WIDTH } from '../nav';

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme }) => ({
    ...bgBlur({ color: theme.palette.background.default }),
    boxShadow: 'none',
    // The desktop layout has the navigation on the side and nothing to put in a top bar
    [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${ NAV_WIDTH + 1 }px)`,
        display: 'none',
    },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    minHeight: HEADER_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: HEADER_DESKTOP,
        padding: theme.spacing(0, 5),
    },
}));

// ----------------------------------------------------------------------

export type HeaderProps = {
    onOpenNav?: () => void;
};

export default function Header({ onOpenNav }: HeaderProps) {
    return (
        <StyledRoot>
            <StyledToolbar>
                <IconButton
                    onClick={ onOpenNav }
                    sx={ {
                        mr: 1,
                        color: 'text.primary',
                        display: { lg: 'none' },
                    } }
                >
                    <Iconify icon="eva:menu-2-fill"/>
                </IconButton>

                <Box sx={ { flexGrow: 1 } }/>

                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={ {
                        xs: 0.5,
                        sm: 1,
                    } }
                >
                </Stack>
            </StyledToolbar>
        </StyledRoot>
    );
}
